import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv2/subpageBgImage.module.scss'

export interface SubpageBgImageProps {
  title: string
  text: string
  image: string
}

const SubpageBgImage: FC<SubpageBgImageProps> = ({ title, text, image }) => {
  const useStyles = makeStyles(() => ({
    bgImage: {
      backgroundImage: `url(${image})`,
    },
  }))
  const classes = useStyles()
  return (
    <section
      className={classNames(classes.bgImage, StylesModule.subpageBgImage)}
    >
      <div className={classNames(StylesModule.subpageBgImage__cover)}>
        <div className={StylesModule.subpageBgImage__wrap}>
          <p className={StylesModule.subpageBgImage__title}>{title}</p>
          <p
            className={StylesModule.subpageBgImage__text}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default SubpageBgImage
